import { render } from "./QTLDetailsModal.vue?vue&type=template&id=10b10105&scoped=true"
import script from "./QTLDetailsModal.js?vue&type=script&lang=js"
export * from "./QTLDetailsModal.js?vue&type=script&lang=js"

import "./QTLDetailsModal.vue?vue&type=style&index=0&id=10b10105&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b10105"]])

export default __exports__